import { render, staticRenderFns } from "./PointGpay.vue?vue&type=template&id=007eb83c"
import script from "./PointGpay.vue?vue&type=script&lang=js"
export * from "./PointGpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports